/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index country-flag to autogenerate all the components and extensions
 * Used by "prepareCountryFlags"
 */

import CountryFlag from './country-flag/CountryFlag'
export * from './country-flag/CountryFlag'
export default CountryFlag
